/** Bilder und Kennzahlen der Kooperationsseite (Texte kommen aus den Übersetzungen) */
export const KOOPERATION_KEY = 'page_kooperation';

export const KOOPERATION_DEFAULTS = {
  hero_image: '/images/cooperation_2.webp',
  partner_logo: '/images/AWGLogo-2.png',
  partner_url: 'https://awg-legaltax.de/',
  stat_values: ['360°', '1×', 'TOP', 'AWG'],
};
